export const ENTITY_TAB_SUB_MENU_SUB_TABS_SKELETON_ITEMS = [
  { value: 'first' },
  { value: 'second' },
]
